export const codigosCopagoModeradora = [
    { nombre: "CUOTA_COPAGO", descriptcion: "Copago" },
    { nombre: "CUOTA_MODERADORA", descriptcion: "Cuota Moderadora" },
]